import api from "../../axios";
import Cookies from "js-cookie";

const login = async (email, password, ip, device) => {
  try {
    const response = await api.post("/api/Auth/Login", {
      email,
      password,
      ip,
      device,
    });

    const data = response.data;

    if (data.status === "Success") {
      // Store JWT Token
      Cookies.set("JWTToken", data.jwtToken, {
        expires: 1,
        secure: false, // true in production with HTTPS
        sameSite: "Lax",
      });

      Cookies.set("userID", data.tokenDetails.userID, {
        expires: 1,
        secure: false,
        sameSite: "Lax",
      });

      Cookies.set("userRole", data.tokenDetails.userRole, {
        expires: 1,
        secure: false,
        sameSite: "Lax",
      });

      Cookies.set("tokenExpiry", data.tokenDetails.tokenExpiry, {
        expires: 1,
        secure: false,
        sameSite: "Lax",
      });
    }

    return data;
  } catch (error) {
    throw (
      error?.response?.data || {
        status: "Fail",
        message: "Something went wrong",
      }
    );
  }
};

const logout = async () => {
  try {
    await api.post("/api/Auth/logout"); // ✅ Send request WITH token first
  } finally {
    Cookies.remove("JWTToken");
    Cookies.remove("userID");
    Cookies.remove("userRole");
    Cookies.remove("tokenExpiry");
  }
};

const VerifyUserAPI = async () => {
  const response = await api.post("/api/Auth/VerifyUser"); // ✅ Send request WITH token first
  return response?.data;
};

const getToken = () => Cookies.get("JWTToken");

export default {
  login,
  logout,
  getToken,
  VerifyUserAPI,
};


export const SendHROtp = (Email) => {
  return api.post("/api/Auth/SendHROtp", Email);
};

export const VerifyHROtp = (Email , OTP) => {
  return api.post("/api/Auth/VerifyHROtp", {Email , OTP});
};

export const VerifyCompanyUserAPI = async () => {
  const response = await api.post('/api/Auth/VerifyCompanyUser');
  return response.data;
};

export const CompanyLogoutAPI = async () => {
  const response = await api.post('/api/Auth/CompanyLogout');
  return response.data;
}